import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FocusDiv } from '@accedo/vdkweb-tv-ui';
import { withFocus } from '@accedo/vdkweb-navigation';
import cx from 'classnames';
import styles from './ProfileToWatchModal.scss';
import BaseModal from '../../common/BaseModal/BaseModal';
import { getModalData } from '#/redux/modules/modal/selectors';
import FocusModal from '../../common/FocusModal/FocusModal';
import { actions as modalActions } from '#/redux/modules/modal/actions';

const FocusSpan = withFocus(({ isFocused, className, nav, ...props }) => (
  <div
    {...props}
    id={nav.id}
    className={cx(className, styles.avatarCont, {
      [styles.focused]: isFocused,
    })}
  />
));

const ProfileToWatchModal = () => {
  const dispatch = useDispatch();
  const { onSwitch, reducedProfiles } = useSelector(state =>
    getModalData(state),
  );
  const keyIds = reducedProfiles.map((el, i) => `key-${i}`);

  const profileTile = useMemo(
    () =>
      reducedProfiles.map((profile, k) => (
        <FocusSpan
          key={k}
          onClick={() => {
            onSwitch(profile.id);
            dispatch(modalActions.closeModal());
          }}
          nav={{
            id: keyIds[k],
            nextdown: 'PROFILES_WATCH_CANCEL_BUTTON',
            nextleft: k === 0 ? undefined : `key-${k - 1}`,
            nextright:
              k + 1 === reducedProfiles.length ? undefined : `key-${k + 1}`,
            parent: 'PROFILES_WATCH',
          }}
        >
          <div className={styles.profileAvatar}>
            <img src={profile.avatar} alt="Profile avatar" />
          </div>
          <div className={styles.profileName}>{profile.name || ''}</div>
        </FocusSpan>
      )),
    [reducedProfiles],
  );
  return (
    <FocusModal>
      <BaseModal
        showSaveButton={false}
        showCancelButton
        cancelButtonText="Dismiss"
        cancelButtonDisabled={false}
        cancelButtonClassName={styles.saveButton}
        className={styles.floatCenter}
        nav={{
          parent: 'PROFILES_WATCH',
          id: 'PROFILES_WATCH_CANCEL_BUTTON',
          nextup: 'PROFILES_WATCH',
        }}
      >
        <FocusDiv
          classNameFocused={styles.tvFocused}
          nav={{ id: 'PROFILES_WATCH', forwardFocus: 'key-0' }}
        >
          <h2>Select a profile to watch</h2>
          <div className={styles.profileCont}>{profileTile}</div>
        </FocusDiv>
      </BaseModal>
    </FocusModal>
  );
};
export default ProfileToWatchModal;
